import { SmartComposeInteraction } from '@qas/smartcompose-tslibrary/dist/src/smartComposeInteraction';

export default function updateTelemetryForSuggestionOnTypedMatchingCharacter(
    suggestionTelemetry: SmartComposeInteraction
) {
    suggestionTelemetry.numberOfMatchingCharactersTyped++;
}
